var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckoutDeliveryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delivery-man 1",
    clipPath: "url(#clip0_24336_8322)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2318 26.7498H1.90735e-05V32.0412C1.90735e-05 33.3495 1.06771 34.418 2.37494 34.418H7.85381L11.1219 36.0688L15.2319 34.418V26.7498H15.2318Z",
    fill: "#FFE07D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8569 19.0713H2.37494C1.06771 19.0713 1.52588e-05 20.1398 1.52588e-05 21.4481V25.3798H15.2318V21.4481C15.2318 20.1398 14.1641 19.0713 12.8569 19.0713Z",
    fill: "#FFE07D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2318 24.1949H1.52588e-05V27.9314H15.2318V24.1949Z",
    fill: "#FF8086"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.17916 24.1949H1.22858H-1.90735e-05V21.4481C-1.90735e-05 20.5542 0.49967 19.7734 1.22858 19.3692C1.57076 19.1809 1.96088 19.0712 2.37502 19.0712H5.5542C4.24697 19.0712 3.17928 20.1397 3.17928 21.448V24.1949H3.17916Z",
    fill: "#FFC269"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.1792 27.9314H1.22861H1.97887e-05V26.7498V25.3799V24.1949H1.22861H3.1792V25.3799V26.7498V27.9314Z",
    fill: "#F76672"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.17916 27.9314V32.0413C3.17916 33.3496 4.24685 34.4181 5.55408 34.4181H2.3749C1.96087 34.4181 1.57076 34.3119 1.22845 34.1236C0.499548 33.716 -0.000137329 32.9352 -0.000137329 32.0413V27.9314H1.22845H3.17916Z",
    fill: "#FFC269"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2318 34.4181H7.85366V37.8121C7.85366 38.6272 8.52093 39.2916 9.33198 39.2916H33.3542C33.3542 37.1579 33.3542 36.0722 31.7219 36.0722L28.4709 36.0688C26.4245 36.0654 25.083 35.5413 24.3336 34.418L15.2318 34.4181Z",
    fill: "#6F6571"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4568 39.2917H9.33212C8.09333 41.4493 7.09747 44.042 7.95646 49.0011C9.39376 44.1104 23.9925 46.0627 25.4913 51.7068H41.5992C42.2084 50.3265 42.7833 48.9634 43.2864 47.5867H38.7452C29.5603 44.1206 32.5136 45.6653 30.4568 39.2917Z",
    fill: "#FFE07D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7606 26.034C31.4457 27.6916 31.018 29.3253 30.5389 30.7157L25.8954 32.5352L20.7176 30.7157C20.899 20.9172 24.5606 16.2184 27.6748 14.6977C28.7972 13.8431 29.947 13.5212 29.947 13.5212C29.947 13.5212 31.4596 15.941 31.5383 15.941C32.12 17.3246 32.3391 19.1295 32.3014 21.0782L31.7606 26.034Z",
    fill: "#ECEAEC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7175 30.7158H30.539C32.801 30.9623 35.5832 32.6851 35.5832 38.021V43.6138L33.3543 44.9414L30.4569 43.6138V39.2915C30.4569 37.1579 30.4569 36.0722 28.8246 36.0722L25.5736 36.0688C23.5272 36.0654 22.1857 35.5413 21.4363 34.4179C20.8579 33.5516 20.6355 32.3288 20.7175 30.7158Z",
    fill: "#FF8086"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7175 30.7158C20.8989 20.9172 24.5605 16.2184 27.6746 14.6978C28.1366 15.0231 28.65 15.2903 29.2146 15.4889C26.4564 17.5746 23.6913 22.2358 23.5339 30.7158H20.7175Z",
    fill: "#DAD8DB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7175 30.7158H23.5339C23.4517 32.3288 23.6741 33.5516 24.2525 34.4181C24.7247 35.127 25.4365 35.7263 26.4119 36.0689H25.5734C23.5269 36.0655 22.1855 35.5414 21.4361 34.4181C20.8579 33.5516 20.6355 32.3288 20.7175 30.7158Z",
    fill: "#F76672"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4913 51.7068C25.4913 46.6415 21.4772 42.6069 16.5254 42.6069C12.4976 42.6069 9.08918 45.2783 7.95645 49.0012C7.72371 49.7649 7.58684 50.5766 7.56293 51.4191C7.55262 51.7479 7.77856 51.7068 8.08653 51.7068C13.887 51.7068 19.6909 51.7034 25.4913 51.7068Z",
    fill: "#FF8086"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2362 51.7067H9.58878C9.78378 55.385 12.7644 58.3099 16.4125 58.3099C20.0605 58.3099 23.0412 55.385 23.2362 51.7067Z",
    fill: "#6F6571"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.892 50.2512L46.1508 52.9534C46.8968 56.1968 50.1307 58.2242 53.3714 57.4776C56.6155 56.731 58.638 53.4946 57.892 50.2512Z",
    fill: "#6F6571"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7714 46.9598C57.1117 44.5453 54.2303 43.1446 51.2188 43.446C45.9076 44.5693 44.1795 47.7442 43.8339 51.7034C43.8407 52.241 43.8989 52.7822 44.0153 53.3234C44.0495 53.4741 44.1487 53.4124 44.313 53.3747L46.1508 52.9534L57.892 50.2512L58.7715 50.0491L60 49.7648C59.7639 48.7305 59.3395 47.7853 58.7714 46.9598Z",
    fill: "#ECEAEC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2291 43.4322L46.4861 27.0204L44.3507 26.0648L41.9621 27.0204C45.1001 35.7195 44.2241 41.7917 42.1057 47.5867C41.5992 48.9635 41.0243 50.3265 40.4186 51.7067H43.8305L51.2291 43.4322Z",
    fill: "#FF8086"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5414 8.61865L30.977 7.43365C30.4124 7.48498 28.7971 8.84131 28.7971 9.69069L29.9811 15.7115C30.4739 15.8589 30.9975 15.941 31.5382 15.941C34.5018 15.941 36.9041 13.5334 36.9041 10.5674C36.9041 9.87901 36.7776 9.22135 36.5414 8.61865Z",
    fill: "#FFECE4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.338 8.61866C38.338 4.78968 35.306 1.69019 31.5622 1.69019C27.8184 1.69019 24.7864 4.78968 24.7864 8.61866C24.7864 11.1462 25.8131 13.3929 27.6748 14.6978C28.3386 15.167 29.1121 15.5129 29.9813 15.7116V9.69058C29.9813 8.8412 30.4124 8.66999 30.9771 8.61855H36.5414L38.338 8.61866Z",
    fill: "#FF8086"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1075 2.71417C34.0774 2.06343 32.8625 1.69019 31.5622 1.69019C27.8184 1.69019 24.7864 4.78968 24.7864 8.61866C24.7864 11.1462 25.8131 13.3929 27.6747 14.6978C28.147 15.03 28.6706 15.3006 29.2455 15.4992C27.8699 14.1053 27.1239 12.1052 27.1239 9.89952C27.1239 5.89933 30.2961 2.65593 34.2076 2.65593C34.5121 2.65593 34.8132 2.67304 35.1075 2.71417Z",
    fill: "#F76672"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5831 43.6138H30.4568V46.8435C30.4568 47.5353 30.8332 47.5867 31.3876 47.5867H38.7451C38.8924 44.3467 36.9315 43.6138 35.5831 43.6138Z",
    fill: "#6F6571"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1057 47.5867C44.224 41.7919 45.1001 35.7196 41.962 27.0204H43.721C43.7278 27.0204 43.7347 27.0204 43.7415 27.0204H44.3746C47.5126 35.7196 46.64 41.7918 44.5184 47.5867C44.0153 48.9635 43.4404 50.3265 42.8312 51.7068H41.5992H40.4186C41.0243 50.3265 41.5992 48.9634 42.1057 47.5867Z",
    fill: "#F76672"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8339 51.7033L51.2188 43.446C51.9819 43.3706 52.7383 43.4014 53.4672 43.535L46.3697 51.4704C46.3765 51.9327 46.421 52.4019 46.51 52.8711L46.1507 52.9533L44.3129 53.3746C44.1486 53.4122 44.0494 53.4739 44.0152 53.3232C43.8989 52.7822 43.8408 52.241 43.8339 51.7033Z",
    fill: "#DAD8DB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.3321 39.2917H30.4568V41.1513H13.0998C11.6865 41.1513 11.0157 41.7609 10.4647 42.9974C9.98905 44.0694 9.97874 44.4188 9.76323 45.7133C8.95218 46.6552 8.32933 47.7717 7.95632 49.0011C7.09745 44.0419 8.09331 41.4493 9.3321 39.2917Z",
    fill: "#FFC269"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.76334 45.7132C11.406 43.8055 13.8254 42.6069 16.5254 42.6069C17.203 42.6069 17.8601 42.6823 18.4931 42.8227C14.4515 43.7371 11.6249 47.3058 11.5017 51.4191C11.4949 51.6451 11.5976 51.6965 11.7617 51.7068H9.58873H8.08638C7.77841 51.7068 7.55248 51.7479 7.56279 51.4191C7.5867 50.5766 7.72357 49.7649 7.95631 49.0012C7.9631 48.9771 7.97002 48.9566 7.97681 48.9361C7.97681 48.9361 7.97681 48.9361 7.97681 48.9327C8.35334 47.7305 8.96587 46.6379 9.76334 45.7132Z",
    fill: "#F76672"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.51 52.8711L57.8921 50.2512C58.0186 50.7888 58.0631 51.33 58.0426 51.8574L49.0083 53.9364L48.6524 54.0185C48.9878 55.4912 49.8399 56.7138 50.9726 57.5393C48.6627 57.1317 46.7086 55.385 46.1508 52.9534L46.51 52.8711Z",
    fill: "#5D5360"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7619 51.7068H23.2363C23.1986 52.426 23.0515 53.1178 22.8153 53.7651H14.8213H12.6483C12.7338 55.3748 13.3497 56.8371 14.3217 57.9776C11.6832 57.1111 9.74295 54.6487 9.58896 51.7067L11.7619 51.7068Z",
    fill: "#5D5360"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8538 37.8121V34.4181H12.4908V37.8121C12.4908 38.6272 13.1581 39.2916 13.9691 39.2916H9.33212C8.52107 39.2917 7.8538 38.6272 7.8538 37.8121Z",
    fill: "#5D5360"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8768 9.99197H32.3048C31.7402 10.0433 31.309 10.218 31.309 11.0674V15.9341C30.8504 15.9136 30.4056 15.8382 29.9812 15.7114V9.69056C29.9812 8.84119 30.4124 8.66998 30.9771 8.61853H36.5414C36.7091 9.05013 36.8254 9.51244 36.8768 9.99197Z",
    fill: "#FFDDCE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.475 21.8523L41.0722 23.9688C40.7573 24.2496 41.1132 27.1128 41.3255 27.0204H46.486H48.7686V22.3078C48.7686 21.3796 48.286 21.5851 47.475 21.8523Z",
    fill: "#FFE07D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0882 27.0204H38.6255H41.3255C43.0639 27.0204 43.1153 24.1366 41.0722 23.9688L38.0882 23.7291L37.2874 25.4244L38.0882 27.0204Z",
    fill: "#FFECE4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3013 21.0782L31.2302 20.1569C28.5473 17.8452 25.1559 21.7461 28.7423 24.075L31.7606 26.034L33.2801 27.0204H38.0881V23.729L35.1007 23.4859L32.3013 21.0782Z",
    fill: "#FF8086"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0882 27.0204V25.4244H38.7281H39.0737H39.6144H42.3144C42.4171 25.4244 42.5129 25.4176 42.6053 25.397C42.7046 26.1915 42.2562 27.0204 41.3254 27.0204H38.6254H38.0882Z",
    fill: "#FFDDCE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7423 24.075C26.5727 22.6639 26.956 20.681 28.1913 19.8453C28.092 20.7015 28.4993 21.6845 29.7313 22.4825L32.0823 24.0065L32.7461 24.4415L34.2656 25.4245H38.0881V27.0205H33.28L31.7606 26.0341L28.7423 24.075Z",
    fill: "#F76672"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0722 23.9688L43.6491 23.1194C44.5114 24.0442 44.929 25.8456 44.3746 27.0204H41.962H41.3255C42.2563 27.0204 42.7045 26.1915 42.6054 25.397C42.5164 24.7086 42.0202 24.0476 41.0722 23.9688Z",
    fill: "#FFC269"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24336_8322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckoutDeliveryIcon);
export default __webpack_public_path__ + "static/media/checkout-delivery-icon.c3f30f2466cb385f72d875a3a2d26173.svg";
export { ForwardRef as ReactComponent };